import { api } from '@/services/api';
import type { Difficulty, ProblemDetail, ProblemFilters, ProblemSummary } from '@/services/types';

interface RawProblemSummary extends Omit<ProblemSummary, 'difficulty'> {
  difficulty: string;
}

interface RawProblemDetail extends Omit<ProblemDetail, 'difficulty'> {
  difficulty: string;
}

export async function listProblems(filters: ProblemFilters = {}) {
  const params: Record<string, string> = {};

  if (filters.difficulty) {
    params.difficulty = filters.difficulty;
  }

  if (filters.category) {
    params.category = filters.category;
  }

  if (filters.tags?.length) {
    params.tags = filters.tags.join(',');
  }

  const response = await api.get<RawProblemSummary[]>('/problems', {
    params,
  });

  return response.data.map((problem) => ({
    ...problem,
    difficulty: normalizeDifficulty(problem.difficulty),
  }));
}

export async function getProblemDetail(problemId: string) {
  const response = await api.get<RawProblemDetail>(`/problems/${problemId}`);
  return {
    ...response.data,
    difficulty: normalizeDifficulty(response.data.difficulty),
  };
}

function normalizeDifficulty(value: string): Difficulty {
  const normalized = value.toUpperCase();

  if (normalized === 'HARD') {
    return 'HARD';
  }

  if (normalized === 'MEDIUM') {
    return 'MEDIUM';
  }

  return 'EASY';
}
